import { render, staticRenderFns } from "./NoMoreCard.vue?vue&type=template&id=72932cf9&"
import script from "./NoMoreCard.vue?vue&type=script&lang=js&"
export * from "./NoMoreCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports